var schema ={
    email:  'required|email',
    otp: 'required|min:6',
    password: 'required|min:8',
    confirmPassword: 'required|confirmed:@password',
    carrierCode: 'required',
    phone: 'required',
    userType: 'required',
    firstName: 'required|alpha',
    lastName: 'required|alpha',
    passcode: 'required|min:4',
    confirmPasscode: 'required|confirmed:@passcode',
};

export default schema;
